import { checkPermission } from "@ROM/Permissions/utils";

export const canInProgressDelivery = (user, customerId) => checkPermission(user, "deliveries:statuses:in-progress", customerId);

export const canShipDelivery = (user, customerId) => checkPermission(user, "deliveries:statuses:ship", customerId);

export const canDeliverDelivery = (user, customerId) => checkPermission(user, "deliveries:statuses:deliver", customerId);

export const canInvoiceDelivery = (user, customerId) => checkPermission(user, "deliveries:statuses:invoice", customerId);
